/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GoogleEmailConfigResponse,
  GoogleEmailConfigUpdateRequest,
  HTTPValidationError,
  SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutParams,
  SettingCreateRequest,
  SettingResponse,
  SettingUpdateRequest,
  VectorSearchSettingsResponse,
  VectorSearchSettingsUpdateRequest
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * Get all system settings. Non-admins only see public settings.
 * @summary Get all settings
 */
export const getSettingsV1SettingsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<SettingResponse[]>(
      {url: `/v1/settings`, method: 'GET', signal
    },
      );
    }
  



export const getGetSettingsV1SettingsGetQueryKey = () => {
    return [
    `/v1/settings`
    ] as const;
    }

    
export const getGetSettingsV1SettingsGetQueryOptions = <TData = Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsV1SettingsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsV1SettingsGet>>> = ({ signal }) => getSettingsV1SettingsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSettingsV1SettingsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsV1SettingsGet>>>
export type GetSettingsV1SettingsGetQueryError = unknown


export function useGetSettingsV1SettingsGet<TData = Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsV1SettingsGet>>,
          TError,
          Awaited<ReturnType<typeof getSettingsV1SettingsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSettingsV1SettingsGet<TData = Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsV1SettingsGet>>,
          TError,
          Awaited<ReturnType<typeof getSettingsV1SettingsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSettingsV1SettingsGet<TData = Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all settings
 */

export function useGetSettingsV1SettingsGet<TData = Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsV1SettingsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSettingsV1SettingsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Create a new system setting (admin only).
 * @summary Create a new setting
 */
export const createSettingV1SettingsPost = (
    settingCreateRequest: SettingCreateRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SettingResponse>(
      {url: `/v1/settings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: settingCreateRequest, signal
    },
      );
    }
  


export const getCreateSettingV1SettingsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSettingV1SettingsPost>>, TError,{data: SettingCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createSettingV1SettingsPost>>, TError,{data: SettingCreateRequest}, TContext> => {

const mutationKey = ['createSettingV1SettingsPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createSettingV1SettingsPost>>, {data: SettingCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createSettingV1SettingsPost(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateSettingV1SettingsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createSettingV1SettingsPost>>>
    export type CreateSettingV1SettingsPostMutationBody = SettingCreateRequest
    export type CreateSettingV1SettingsPostMutationError = HTTPValidationError

    /**
 * @summary Create a new setting
 */
export const useCreateSettingV1SettingsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createSettingV1SettingsPost>>, TError,{data: SettingCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createSettingV1SettingsPost>>,
        TError,
        {data: SettingCreateRequest},
        TContext
      > => {

      const mutationOptions = getCreateSettingV1SettingsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get a specific system setting by key.
 * @summary Get a specific setting
 */
export const getSettingV1SettingsSettingKeyGet = (
    settingKey: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<SettingResponse>(
      {url: `/v1/settings/${settingKey}`, method: 'GET', signal
    },
      );
    }
  



export const getGetSettingV1SettingsSettingKeyGetQueryKey = (settingKey?: string,) => {
    return [
    `/v1/settings/${settingKey}`
    ] as const;
    }

    
export const getGetSettingV1SettingsSettingKeyGetQueryOptions = <TData = Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError = HTTPValidationError>(settingKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingV1SettingsSettingKeyGetQueryKey(settingKey);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>> = ({ signal }) => getSettingV1SettingsSettingKeyGet(settingKey, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(settingKey), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetSettingV1SettingsSettingKeyGetQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>>
export type GetSettingV1SettingsSettingKeyGetQueryError = HTTPValidationError


export function useGetSettingV1SettingsSettingKeyGet<TData = Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError = HTTPValidationError>(
 settingKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>,
          TError,
          Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSettingV1SettingsSettingKeyGet<TData = Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError = HTTPValidationError>(
 settingKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>,
          TError,
          Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetSettingV1SettingsSettingKeyGet<TData = Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError = HTTPValidationError>(
 settingKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a specific setting
 */

export function useGetSettingV1SettingsSettingKeyGet<TData = Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError = HTTPValidationError>(
 settingKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingV1SettingsSettingKeyGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetSettingV1SettingsSettingKeyGetQueryOptions(settingKey,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update an existing system setting (admin only).
 * @summary Update a setting
 */
export const updateSettingV1SettingsSettingKeyPut = (
    settingKey: string,
    settingUpdateRequest: SettingUpdateRequest,
 ) => {
      
      
      return customInstance<SettingResponse>(
      {url: `/v1/settings/${settingKey}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: settingUpdateRequest
    },
      );
    }
  


export const getUpdateSettingV1SettingsSettingKeyPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettingV1SettingsSettingKeyPut>>, TError,{settingKey: string;data: SettingUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateSettingV1SettingsSettingKeyPut>>, TError,{settingKey: string;data: SettingUpdateRequest}, TContext> => {

const mutationKey = ['updateSettingV1SettingsSettingKeyPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSettingV1SettingsSettingKeyPut>>, {settingKey: string;data: SettingUpdateRequest}> = (props) => {
          const {settingKey,data} = props ?? {};

          return  updateSettingV1SettingsSettingKeyPut(settingKey,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateSettingV1SettingsSettingKeyPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateSettingV1SettingsSettingKeyPut>>>
    export type UpdateSettingV1SettingsSettingKeyPutMutationBody = SettingUpdateRequest
    export type UpdateSettingV1SettingsSettingKeyPutMutationError = HTTPValidationError

    /**
 * @summary Update a setting
 */
export const useUpdateSettingV1SettingsSettingKeyPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettingV1SettingsSettingKeyPut>>, TError,{settingKey: string;data: SettingUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateSettingV1SettingsSettingKeyPut>>,
        TError,
        {settingKey: string;data: SettingUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateSettingV1SettingsSettingKeyPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Delete a system setting (admin only).
 * @summary Delete a setting
 */
export const deleteSettingV1SettingsSettingKeyDelete = (
    settingKey: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/v1/settings/${settingKey}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteSettingV1SettingsSettingKeyDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSettingV1SettingsSettingKeyDelete>>, TError,{settingKey: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteSettingV1SettingsSettingKeyDelete>>, TError,{settingKey: string}, TContext> => {

const mutationKey = ['deleteSettingV1SettingsSettingKeyDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSettingV1SettingsSettingKeyDelete>>, {settingKey: string}> = (props) => {
          const {settingKey} = props ?? {};

          return  deleteSettingV1SettingsSettingKeyDelete(settingKey,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSettingV1SettingsSettingKeyDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSettingV1SettingsSettingKeyDelete>>>
    
    export type DeleteSettingV1SettingsSettingKeyDeleteMutationError = HTTPValidationError

    /**
 * @summary Delete a setting
 */
export const useDeleteSettingV1SettingsSettingKeyDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSettingV1SettingsSettingKeyDelete>>, TError,{settingKey: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSettingV1SettingsSettingKeyDelete>>,
        TError,
        {settingKey: string},
        TContext
      > => {

      const mutationOptions = getDeleteSettingV1SettingsSettingKeyDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get the default company used for HR data queries when not explicitly specified.
 * @summary Get default company for HR queries
 */
export const getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/settings/default/company_hr_dataset`, method: 'GET', signal
    },
      );
    }
  



export const getGetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGetQueryKey = () => {
    return [
    `/v1/settings/default/company_hr_dataset`
    ] as const;
    }

    
export const getGetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGetQueryOptions = <TData = Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>> = ({ signal }) => getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGetQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>>
export type GetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGetQueryError = unknown


export function useGetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet<TData = Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>,
          TError,
          Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet<TData = Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>,
          TError,
          Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet<TData = Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get default company for HR queries
 */

export function useGetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet<TData = Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultCompanyV1SettingsDefaultCompanyHrDatasetGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDefaultCompanyV1SettingsDefaultCompanyHrDatasetGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Set the default company used for HR data queries (admin only).
 * @summary Set default company for HR queries
 */
export const setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut = (
    params: SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutParams,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/v1/settings/default/company_hr_dataset`, method: 'PUT',
        params
    },
      );
    }
  


export const getSetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut>>, TError,{params: SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut>>, TError,{params: SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutParams}, TContext> => {

const mutationKey = ['setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut>>, {params: SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutParams}> = (props) => {
          const {params} = props ?? {};

          return  setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutMutationResult = NonNullable<Awaited<ReturnType<typeof setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut>>>
    
    export type SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutMutationError = HTTPValidationError

    /**
 * @summary Set default company for HR queries
 */
export const useSetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut>>, TError,{params: SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDefaultCompanyV1SettingsDefaultCompanyHrDatasetPut>>,
        TError,
        {params: SetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutParams},
        TContext
      > => {

      const mutationOptions = getSetDefaultCompanyV1SettingsDefaultCompanyHrDatasetPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get current vector search settings (similarity threshold and result limit).
 * @summary Get vector search configuration
 */
export const getVectorSearchConfigV1SettingsVectorSearchConfigGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<VectorSearchSettingsResponse>(
      {url: `/v1/settings/vector-search/config`, method: 'GET', signal
    },
      );
    }
  



export const getGetVectorSearchConfigV1SettingsVectorSearchConfigGetQueryKey = () => {
    return [
    `/v1/settings/vector-search/config`
    ] as const;
    }

    
export const getGetVectorSearchConfigV1SettingsVectorSearchConfigGetQueryOptions = <TData = Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVectorSearchConfigV1SettingsVectorSearchConfigGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>> = ({ signal }) => getVectorSearchConfigV1SettingsVectorSearchConfigGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetVectorSearchConfigV1SettingsVectorSearchConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>>
export type GetVectorSearchConfigV1SettingsVectorSearchConfigGetQueryError = unknown


export function useGetVectorSearchConfigV1SettingsVectorSearchConfigGet<TData = Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetVectorSearchConfigV1SettingsVectorSearchConfigGet<TData = Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetVectorSearchConfigV1SettingsVectorSearchConfigGet<TData = Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get vector search configuration
 */

export function useGetVectorSearchConfigV1SettingsVectorSearchConfigGet<TData = Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVectorSearchConfigV1SettingsVectorSearchConfigGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetVectorSearchConfigV1SettingsVectorSearchConfigGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update vector search settings (admin only). Changes apply to all future searches.
 * @summary Update vector search configuration
 */
export const updateVectorSearchConfigV1SettingsVectorSearchConfigPut = (
    vectorSearchSettingsUpdateRequest: VectorSearchSettingsUpdateRequest,
 ) => {
      
      
      return customInstance<VectorSearchSettingsResponse>(
      {url: `/v1/settings/vector-search/config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vectorSearchSettingsUpdateRequest
    },
      );
    }
  


export const getUpdateVectorSearchConfigV1SettingsVectorSearchConfigPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVectorSearchConfigV1SettingsVectorSearchConfigPut>>, TError,{data: VectorSearchSettingsUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVectorSearchConfigV1SettingsVectorSearchConfigPut>>, TError,{data: VectorSearchSettingsUpdateRequest}, TContext> => {

const mutationKey = ['updateVectorSearchConfigV1SettingsVectorSearchConfigPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVectorSearchConfigV1SettingsVectorSearchConfigPut>>, {data: VectorSearchSettingsUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateVectorSearchConfigV1SettingsVectorSearchConfigPut(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateVectorSearchConfigV1SettingsVectorSearchConfigPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateVectorSearchConfigV1SettingsVectorSearchConfigPut>>>
    export type UpdateVectorSearchConfigV1SettingsVectorSearchConfigPutMutationBody = VectorSearchSettingsUpdateRequest
    export type UpdateVectorSearchConfigV1SettingsVectorSearchConfigPutMutationError = HTTPValidationError

    /**
 * @summary Update vector search configuration
 */
export const useUpdateVectorSearchConfigV1SettingsVectorSearchConfigPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVectorSearchConfigV1SettingsVectorSearchConfigPut>>, TError,{data: VectorSearchSettingsUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVectorSearchConfigV1SettingsVectorSearchConfigPut>>,
        TError,
        {data: VectorSearchSettingsUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateVectorSearchConfigV1SettingsVectorSearchConfigPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get current Google OAuth configuration for email integration (admin only).
 * @summary Get Google email configuration
 */
export const getGoogleEmailConfigV1SettingsGoogleEmailConfigGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GoogleEmailConfigResponse>(
      {url: `/v1/settings/google-email/config`, method: 'GET', signal
    },
      );
    }
  



export const getGetGoogleEmailConfigV1SettingsGoogleEmailConfigGetQueryKey = () => {
    return [
    `/v1/settings/google-email/config`
    ] as const;
    }

    
export const getGetGoogleEmailConfigV1SettingsGoogleEmailConfigGetQueryOptions = <TData = Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGoogleEmailConfigV1SettingsGoogleEmailConfigGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>> = ({ signal }) => getGoogleEmailConfigV1SettingsGoogleEmailConfigGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetGoogleEmailConfigV1SettingsGoogleEmailConfigGetQueryResult = NonNullable<Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>>
export type GetGoogleEmailConfigV1SettingsGoogleEmailConfigGetQueryError = unknown


export function useGetGoogleEmailConfigV1SettingsGoogleEmailConfigGet<TData = Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGoogleEmailConfigV1SettingsGoogleEmailConfigGet<TData = Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetGoogleEmailConfigV1SettingsGoogleEmailConfigGet<TData = Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get Google email configuration
 */

export function useGetGoogleEmailConfigV1SettingsGoogleEmailConfigGet<TData = Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGoogleEmailConfigV1SettingsGoogleEmailConfigGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetGoogleEmailConfigV1SettingsGoogleEmailConfigGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update Google OAuth configuration for email integration (admin only).
 * @summary Update Google email configuration
 */
export const updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut = (
    googleEmailConfigUpdateRequest: GoogleEmailConfigUpdateRequest,
 ) => {
      
      
      return customInstance<GoogleEmailConfigResponse>(
      {url: `/v1/settings/google-email/config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: googleEmailConfigUpdateRequest
    },
      );
    }
  


export const getUpdateGoogleEmailConfigV1SettingsGoogleEmailConfigPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut>>, TError,{data: GoogleEmailConfigUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut>>, TError,{data: GoogleEmailConfigUpdateRequest}, TContext> => {

const mutationKey = ['updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut>>, {data: GoogleEmailConfigUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateGoogleEmailConfigV1SettingsGoogleEmailConfigPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut>>>
    export type UpdateGoogleEmailConfigV1SettingsGoogleEmailConfigPutMutationBody = GoogleEmailConfigUpdateRequest
    export type UpdateGoogleEmailConfigV1SettingsGoogleEmailConfigPutMutationError = HTTPValidationError

    /**
 * @summary Update Google email configuration
 */
export const useUpdateGoogleEmailConfigV1SettingsGoogleEmailConfigPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut>>, TError,{data: GoogleEmailConfigUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateGoogleEmailConfigV1SettingsGoogleEmailConfigPut>>,
        TError,
        {data: GoogleEmailConfigUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateGoogleEmailConfigV1SettingsGoogleEmailConfigPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Disconnect the connected Google email account (admin only).
 * @summary Disconnect Google email account
 */
export const disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/v1/settings/google-email/disconnect`, method: 'POST', signal
    },
      );
    }
  


export const getDisconnectGoogleEmailV1SettingsGoogleEmailDisconnectPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost>>, TError,void, TContext> => {

const mutationKey = ['disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost>>, void> = () => {
          

          return  disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost()
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DisconnectGoogleEmailV1SettingsGoogleEmailDisconnectPostMutationResult = NonNullable<Awaited<ReturnType<typeof disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost>>>
    
    export type DisconnectGoogleEmailV1SettingsGoogleEmailDisconnectPostMutationError = unknown

    /**
 * @summary Disconnect Google email account
 */
export const useDisconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disconnectGoogleEmailV1SettingsGoogleEmailDisconnectPost>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDisconnectGoogleEmailV1SettingsGoogleEmailDisconnectPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    